import React from "react";
import "./App.scss";
import { ThreeViewer } from "./features/three";
import Panel from "./features/panel/components/Panel";
import { useDispatch, useSelector } from "react-redux";
import { open } from "./features/panel/panelSlice";
import Header from "./features/valtra/components/Header";
import ValtraButton from "./features/valtra/components/ValtraButton";
import LoadingView from "./features/valtra/components/LoadingView";
import { selectView, setValue } from "./features/context/contextSlice";
import { selectText } from "./features/translation/translationSlice";
import {
  rotate,
  selectLoaded,
  selectStarted,
} from "./features/three/threeSlice";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { hideHeader, showBackButton, contact, share } from "./data";
import { showContactDialog } from "./features/app/appSlice";
import Contact from "./features/valtra/components/Contact";

function App() {
  const handle = useFullScreenHandle();
  const dispatch = useDispatch();
  const t = useSelector(selectText);
  const started = useSelector(selectStarted);
  const loaded = useSelector(selectLoaded);
  const view = useSelector(selectView);
  const viewAction =
    view === "exterior"
      ? { path: "tractor/view", value: "interior" }
      : { path: "tractor/view", value: "exterior" };

  const gotoViewLabel =
    view === "exterior" ? t("ui-go-inside") : t("ui-go-outside");

  return (
    <FullScreen handle={handle}>
      <div className="App">
        <div className="abs-100">
          {started && <ThreeViewer />}
          <LoadingView />
          {!hideHeader && <Header />}
          <div className="BottomBar">
            <div className="BottomBar_left">
              {loaded && (
                <ValtraButton
                  className="with-tablet-up-label"
                  icon={<i className="icon-menu" />}
                  label={t("ui-configuration")}
                  onClick={(e) => dispatch(open())}
                />
              )}
            </div>
            <div
              className="BottomBar_center"
              onClick={(e) => dispatch(setValue(viewAction))}
            >
              {loaded && (
                <ValtraButton
                  icon={<i className="icon-door" />}
                  className="with-mobile-up-label"
                  label={gotoViewLabel}
                />
              )}
            </div>
            <div className="BottomBar_right">
              {loaded && (
                <ValtraButton
                  icon={<i className="icon-rotate" />}
                  onClick={(e) => dispatch(rotate())}
                />
              )}
              {handle.active && (
                <ValtraButton
                  icon={<i className="icon-windowed" />}
                  onClick={handle.exit}
                />
              )}
              {!handle.active && (
                <ValtraButton
                  icon={<i className="icon-fullscreen" />}
                  className="with-tablet-up"
                  onClick={handle.enter}
                />
              )}
            </div>
          </div>
          {loaded && showBackButton && (
            <ValtraButton
              icon={<i className="icon-chevron-left" />}
              className="back-to-showroom"
              label={t("ui-back-to-showroom")}
              onClick={(e) => window.history.back()}
            />
          )}
          {loaded && (showBackButton || contact) && (
            <ValtraButton
              icon={<i className="icon-contact" />}
              className="contact-us"
              label={t("ui-contact-us")}
              onClick={(e) => dispatch(showContactDialog())}
            />
          )}
          <Panel />
          <Contact />
        </div>
      </div>
    </FullScreen>
  );
}

export default App;
